"use strict";
/// <reference path="../../../Trillium.UI/TypeScript/Models/Website/FolderListViewModal.tsx"/>
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var FolderListDialog = function (props) {
    return (react_1.default.createElement(core_1.Dialog, { onClose: props.onClose, "aria-labelledby": "simple-dialog-title", open: props.open, className: 'ipd-portal folder_list', maxWidth: 'lg' },
        react_1.default.createElement(core_1.DialogTitle, { id: "simple-dialog-title" }, "Select folder"),
        react_1.default.createElement(core_1.DialogContent, null,
            props.children,
            react_1.default.createElement("img", { src: '/images/icons/close.svg', className: 'closeIcon cursor-pointer', onClick: props.onClose }),
            props.error ? react_1.default.createElement("span", null, "Something went wrong while moving document") : null),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { onClick: props.onClose, className: 'btn btn-primary btn-primary-outline  mr-auto' }, props.cancleButton),
            props.anySelect ? react_1.default.createElement(core_1.Button, { onClick: props.onContinue, className: 'btn btn-primary' }, props.moveButton) : null)));
};
exports.default = FolderListDialog;
